import { remark } from 'remark';
import strip from 'strip-markdown';

export const removeMarkdownFromText = async (text: string): Promise<string> => {
  const parsedText = await remark().use(strip).process(text);

  return String(parsedText);
};
